import React, { useState, useEffect } from "react";
import classes from "./RegisterTempUser.module.scss";
import { useNavigate } from "react-router-dom";
import headerImage from "../../static/images/header_icon.svg";
import { postUnregisteredUsers } from "../../api/UsersApi";
import { atom, useAtom } from "jotai";
export const mailTmpAtom = atom<string>("");
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import TextForm, { TextFormResult } from "../../atoms/text-form/TextForm";
import { validators } from "../../common/utility/validator.util";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import lineIcon from "../../static/images/common/line_icon.png";

const RegisterTempUser = () => {
  const navigate = useNavigate();
  const postUnregisteredUserApi = postUnregisteredUsers();
  const [mail, setMail] = useAtom(mailTmpAtom);

  const isSubmitting = postUnregisteredUserApi.state?.status === "processing";

  const mailValidator = (value: string) => {
    const required = validators.required(value);
    if (!required.status) return required;
    return validators.mail(value);
  };

  const register = () => {
    // 二重送信ガード：送信中は何もしない
    if (isSubmitting) return;
        
    const diagnosisType = "no_diagnosis";
    postUnregisteredUserApi.post({
      diagnosisType,
      emailAddress: mail,
    });
  };

  useEffect(() => {
    postUnregisteredUserApi.reset?.(); 
  }, []);

  useEffect(() => {
    if (postUnregisteredUserApi.state?.status === "success") {
      navigate("/register-result", { state: { from: "RegisterTempUser" } });
    }
  }, [postUnregisteredUserApi.state?.status, navigate]);

  const onLineLonginClick = () => {
    // LINEログインへリダイレクト(LineLoginApi にGETリクエストを送る)
    window.location.href = "https://miraii-concierge.jp/swan/api/line/login";
  };
  
  return (
    <>
      <div className={classes.container}>
        <img src={headerImage} alt="header" />
        <div className={classes.body}>
          <div className={classes.registerContainer}>
            <div className={classes.registerTitle}>会員登録（無料）</div>
            <div className={classes.registerHeader}>
              ドメイン指定受信を設定されている方にはメールが正しく届かないことがあります。
            </div>
            <div className={classes.registerHeader}>
              「@miraii-concierge.jp」の受信許可をお願いします。
            </div>z1
            <div className={classes.registerForm}>
              <TextForm
                label="メールアドレス"
                type="text"
                name="mail"
                value={mail}
                color="white"
                inputWidth="100%"
                onChange={(args: TextFormResult) => setMail(args.value)}
                validator={mailValidator}
              />
            </div>
            <SimpleButton
              label={isSubmitting ? "送信中..." : "利用規約に同意して登録する"}
              width="100%"
              color="orange"
              isRadius={true}
              onClick={register}
              disabled={isSubmitting || mailValidator(mail).status === false}
            />
            <div className={classes.registerCaption}>
              <a target="_blank" href="serviceterm" className={classes.link} rel="noreferrer">
                利用規約
              </a>
              <span>に同意の上、登録へお進みください。</span>
            </div>
            <div className={classes.label}>────  または  ────</div>
            <div className={classes.lineButtonArea}>
              <SimpleButton
                label="LINE IDで登録する"
                width="100%"
                isRadius={true}
                color="lightgreen"
                textColor="black"
                leftIcon={lineIcon}
                onClick={onLineLonginClick}
              ></SimpleButton>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.breadCrumb}>
        <BreadCrumb
          data={[
            { displayName: "みらいいコンシェル" , url: "/login" },
            { displayName: "会員登録" },
          ]}
        />
      </div>
    </>
  );
};

export default RegisterTempUser;
